import { useCallback, useContext, useEffect, useState } from 'react';
import { AudioRecorderContext } from '../context/audio-recorder-context';
import { useExternalState } from './use-external-state';

export const useOutputList = () => {
  const ctx = useContext(AudioRecorderContext);
  return useExternalState(ctx.recorder!.outputState)
}